const columns = [
    {
        title: 'Payment From',
        dataIndex: 'paymentFrom',
    },
    {
        title: 'Payment To',
        dataIndex: 'paymentTo',
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
    },
    {
        title: 'Transaction Date',
        dataIndex: 'transactionDate',
    },
    {
        title: 'Status',
        dataIndex: 'status',
    },
];

export default columns;